import * as CONSTANTS from '@redbubble/design-system/react/constants';
import { useViewportWidth } from '@redbubble/next/hooks';
import { DeviceType } from '@redbubble/next/types';

export const useConfiguratorViewportProfile = () => {
  return useViewportWidth().isOrAbove(DeviceType.Desktop)
    ? CONSTANTS.DESKTOP
    : CONSTANTS.MOBILE;
};
